import { inject, injectable } from 'inversify-props';
import { ILineService } from './ILineService';
import { ILinesApiId, ILinesApi } from './ILinesApi';
import { Line } from './Line';

@injectable()
export default class LineService implements ILineService {
    @inject(ILinesApiId)
    api!: ILinesApi;

    async getLines(calendarDay: string): Promise<Line[]> {
        try {
            return await this.api.getLines(calendarDay);
        } catch {
            return new Array<Line>();
        }
    }
}
